import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/templates`;
const PREVIEWS = `${BASE}/previews/available_now`;

export const disneyAvailableNow = defineTemplate({
  mode: 'legacy',
  id: 'available-now',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'Ya disponible',
  thumbnail: {
    url: `${BASE}/thumbnails/ya_disponible_vertical.png`,
    optimizedUrl: `${BASE}/thumbnails/optimized/ya_disponible_vertical.png`,

    aspectRatio: 'vertical'
  },
  previewByResolution: {
    '300x250': { kind: 'video', url: `${PREVIEWS}/available_now_300x250.mp4` },
    '300x600': { kind: 'video', url: `${PREVIEWS}/available_now_300x600.mp4` },
    '1080x1350': { kind: 'video', url: `${PREVIEWS}/available_now_1080x1350.mp4` },
    '1080x1080': { kind: 'video', url: `${PREVIEWS}/available_now_1080x1080.mp4` },
    '1080x1920': { kind: 'video', url: `${PREVIEWS}/available_now_1080x1920.mp4` },
    '1920x1080': { kind: 'video', url: `${PREVIEWS}/available_now_1920x1080.mp4` }
  },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'videoLink',
      label: 'Video',
      type: 'video',
      placeholder: 'https://cdn.filestackcontent.com/...',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/available-now/video.png'
    },
    {
      key: 'text',
      label: 'Texto del video',
      type: 'select',
      options: [
        { value: 'YA DISPONIBLE', label: 'YA DISPONIBLE' },
        { value: 'AVANCE', label: 'AVANCE' },
        { value: 'AHORA', label: 'AHORA' },
        { value: 'PRÓXIMAMENTE', label: 'PRÓXIMAMENTE' },
        { value: 'DESTACADO', label: 'DESTACADO' },
        { value: 'MUY PRONTO', label: 'MUY PRONTO' },
        { value: 'LO NUEVO', label: 'LO NUEVO' },
        { value: 'custom', label: 'Otro (personalizado)' }
      ],
      allowCustomInput: true,
      defaultValue: 'YA DISPONIBLE',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/available-now/text.png'
    },
    {
      key: 'textColor',
      label: 'Color del texto',
      type: 'select',
      options: [
        { value: 'white', label: 'Pure White' },
        { value: 'color', label: 'Bright Aurora' }
      ],
      defaultValue: 'color',
      required: false
    }
  ],
  promptTemplate: `Haceme una creatividad "Ya disponible"
con este texto: "YA DISPONIBLE"
usando este video: "${process.env.REACT_APP_MEDIA_DOMAIN}/TESTDISNEY/examples/movies/05-quebranto.mp4"
con letras de color: "Pure White o Bright Aurora"`
});
